<template>
  <form @submit.prevent="onSave">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('user.form.role_information') }}</h4>
            <p class="sub-header"></p>
            <div class="row">
              <div class="col-6">
                <TextField
                  placeholder="Enter Role"
                  label="Role"
                  v-model="model.name"
                />
                <div  v-for="option in roleOptions"
                    :key="option.value">
                  <div
                   
                    v-if="user.role.type === option.type || user.role.type === 1"
                  >
                    <input
                      type="radio"
                      :value="option.value"
                      v-model="model.role"
                      @input="model.type = option.type"
                    />
                    <label>{{ option.label }}</label>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <Tree
                  id="my-tree-id"
                  ref="my-tree-ref"
                  v-model="model.modules"
                  :custom-options="myCustomOptions"
                  :custom-styles="myCustomStyles"
                  :nodes="data"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import TextField from "@components/form2/textfield.vue";
import { mapActions } from "vuex";
import FormMixin from "@mixins/form";

export default {
  mixins: [FormMixin],
  components: {
    TextField,
  },
  props: {
    parameters: null,
  },
  setup() {
    const fullWidth = ref(window.innerWidth);

    const handleResize = () => {
      fullWidth.value = window.innerWidth;
      const header = document.getElementById("sticky-header");
      if (header) {
        header.style.width = fullWidth.value + "px";
      }
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    return { fullWidth };
  },
  data() {
    return {
      data: [],
      model: {
        name: "",
        role: "",
        type: Number,
      },
      editedData: {},
      roleOptions: [
        { value: "administration", label: "Super Admin", type: 1 },
        { value: "staff", label: "Administration/Staff", type: 1 },
        { value: "recruitment", label: "Recruitment", type: 2 },
        { value: "individual", label: "Individual", type: 3 },
        { value: "candidate", label: "Candidate", type: 4 },
        { value: "customer", label: "Customer", type: 5 },
      ],
    };
  },
  async beforeMount() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("role", ["find"]),
    async fetchData() {
      try {
        const data = await this.find({
          id: this.parameters.rowId._id,
        });
        this.model = data.data.role;
        this.editedData = data.data;
        this.data = data.data.modules;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },
  computed: {
    myCustomStyles() {
      return {
        row: {
          style: {
            width: "500px",
            cursor: "pointer",
          },
          child: {
            class: "",
            style: {
              height: "35px",
            },
            active: {
              class: "custom_row_active_class",
              style: {
                height: "35px",
              },
            },
          },
        },
        addNode: {
          class: "custom_class",
          style: {
            color: "#007AD5",
          },
        },
        editNode: {
          class: "custom_class",
          style: {
            color: "#007AD5",
          },
        },
        deleteNode: {
          class: "custom_class",
          style: {
            color: "#EE5F5B",
          },
        },
        selectIcon: {
          class: "custom_class",
          style: {
            color: "#007AD5",
          },
          active: {
            class: "custom_class",
            style: {
              color: "#2ECC71",
            },
          },
        },
        text: {
          style: {},
          class: "capitalize",
          active: {
            style: {
              "font-weight": "bold",
              color: "#2ECC71",
            },
          },
        },
      };
    },
    myCustomOptions() {
      return {
        treeEvents: {
          expanded: {
            state: true,
            fn: null,
          },
          collapsed: {
            state: false,
            fn: null,
          },
          selected: {
            state: false,
            fn: null,
          },
          checked: {
            state: true,
            fn: this.myCheckedFunction,
          },
        },
        events: {
          expanded: {
            state: true,
            fn: null,
          },
          selected: {
            state: false,
            fn: null,
          },
          checked: {
            state: false,
            fn: null,
          },
          editableName: {
            state: false,
            fn: null,
            calledEvent: null,
          },
        },
        addNode: { state: false, fn: null, appearOnHover: false },
        editNode: { state: true, fn: null, appearOnHover: true },
        deleteNode: { state: true, fn: null, appearOnHover: true },
        showTags: true,
      };
    },
  },
};
</script>
